import React from "react";
import Banner6 from "../partials/Banner/Banner6";
import Section1 from "../includes/WhenPorchPiratesStrike/Section1";
import { Helmet } from "react-helmet";

const WhenPorchPiratesStrike = ({ devUrl }) => {
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://brainbox.company/blogs/when-porch-pirates-strike",
    },
    headline: "How and when porch pirates stole your packages?",
    image: "https://brainbox.company/images/blogs/blog-6.png",
    author: {
      "@type": "Organization",
      name: "Brain Box",
      url: "https://brainbox.company",
    },
    publisher: {
      "@type": "Organization",
      name: "Brain Box",
      logo: {
        "@type": "ImageObject",
        url: "https://brainbox.company/images/logo-b.png",
      },
    },
    datePublished: "2023-03-21",
    dateModified: "2023-03-22",
  };

  const imgPath = "url(" + devUrl + "images/our-team/ourteam-banner.png)";

  const bgColor = "$blue-color";
  const minHeight = "400px";

  return (
    <>
      <Helmet>
        <title>Porch pirate stole your package. How?</title>
        <meta
          name="description"
          content="Porch piracy can occur at any time of the day, but there are certain hours of the day when porch pirates are more likely to strike."
        />
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
        <link
          rel="canonical"
          href="https://brainbox.company/blogs/when-porch-pirates-strike"
        />
      </Helmet>
      <main>
        <article className="our-team">
          <Banner6
            imgPath={imgPath}
            bgColor={bgColor}
            minHeight={minHeight}
            text1={"Porch pirate stole your package. How?"}
          />
          <div className="bg-design">
            <Section1 url={devUrl} />
          </div>
        </article>
      </main>
    </>
  );
};

export default React.memo(WhenPorchPiratesStrike);
